<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      d="M17.7497 3H20.8179L14.1165 10.624L22 21H15.8288L10.9917 14.7087L5.46371 21H2.39113L9.55758 12.8438L2 3H8.32768L12.6953 8.75048L17.7497 3ZM16.6719 19.174H18.3711L7.402 4.73077H5.57671L16.6719 19.174Z"
    />
  </svg>
</template>
